import React, { useState, useEffect, useContext } from "react";
import war from "../../src/assets/images/war.png";
import like from "../../src/assets/images/likes.png";
import User from '../../src/assets/images/User.svg'
import recomented from '../../src/assets/images/recomented.jpeg'
import Refresh from '../../src/assets/images/Refresh cw.svg'
import CustomButton from "../component/button";
import { useSelector, useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import { updateFormField, } from './Slices/formSlice';
import { AppContext } from "../context/AppContext";
import { TITLE_COLOR_MAP } from "../component/skeletons/colorMap";
import { ApiConfig } from "../Api/ApiConfig";
import { fetchPOST, } from "../Api/ApiServices";
import { toastMsg } from "../component/toast";
import Modal from 'react-bootstrap/Modal';
import { personalitiesList } from "../component/skeletons/PersonalitiesList";

export const COLOR_TITLE_GROUPS = [
  {
    groupName: 'A',
    color: "#34D399",
    titles: ["Patience", "Persistence", "Thoughtfulness"]
  },
  {
    groupName: 'B',
    color: "#B6A1FB",
    titles: ["Enthusiasm", "Friendliness", "Self Confidence"]
  },
  {
    groupName: 'C',
    color: "#F17D8B",
    titles: ["Efficiency", "Independence", "Self Motivation"]
  },
  {
    groupName: 'D',
    color: "#FBC43B",
    titles: ["Accuracy", "Cooperativeness", "Sensitivity"]
  }
];



export default function BehaviorsPage({ selectedBehaviorFromApi, setSelectedBehaviorFromApi, isSuperVission = false, selectedBehavoiurTwo, setSelectedBehavoiurTwo, setPersonalityMatchTwo, modal = false, handleCloseBehaviour, setIsTwoPer, setPersonalityMatchingData, calucluatePersonalityPercentage }) {
  const { openSideBar, setOpenSideBar, activeMenu, setActiveMenu } =
    useContext(AppContext);

  const formData = useSelector((state) => state.form);
  const dispatch = useDispatch()
  const [selectedRecommendedIndexes, setSelectedRecommendedIndexes] = useState(
    []
  );
  const navigate = useNavigate();
  const [CheckPersonalityData, setcheckPersonalityData] = useState([]);
  const [titleToShowOnBehaviorModal, setTitleToShowOnBehaviorModal] = useState('')
  const [checkPersonalityLoading, setCheckPersonalityLoading] = useState(false);
  const [isLoadingTwo, setIsLoadingTwo] = useState(false)
  const [selectedOtherIndexes, setSelectedOtherIndexes] = useState([]);
  const [combinePopupData, setCombinePopupData] = useState([]);
  const [isTwo, setisTwo] = useState(false)
  const [expandedStatusIndexes, setExpandedStatusIndexes] = useState([]);
  const [expandedIgnoreIndexes, setExpandedIgnoreIndexes] = useState([]);
  const [modalText, setModalText] = useState('Unable to Select')
  const [personalitytwosel, setPersonalityTwo] = useState([])

  const MAX_SELECTION = 4;
  const totalSelectedCount =
    selectedRecommendedIndexes.length + selectedOtherIndexes.length;




  const behaviorData = [
    {
      title: "Leader",
      status: "Why select this ?",
      ignoreStatus: "When to avoid ?",
      // bgColor: "#F4F8E4",
      // borderColor: "#ffe28c",
      bgColor: "#E2FAEE",
      borderColor: "#8dd7cf",
      percentage: "",
    },
    {
      title: "Leader",
      status: "Why select this ?",
      ignoreStatus: "When to avoid ?",
      // bgColor: "#EBF1F7",
      // borderColor: "#97c2eb",
      bgColor: "#E2FAEE",
      borderColor: "#8dd7cf",
      percentage: "",
    },
    {
      title: "Leader",
      status: "Why select this ?",
      ignoreStatus: "When to avoid ?",
      bgColor: "#E2FAEE",
      borderColor: "#8dd7cf",
      percentage: "",
    },
    {
      title: "Leader",
      status: "Why select this ?",
      ignoreStatus: "When to avoid ?",
      // bgColor: "#F4EFEB",
      // borderColor: "#e5929f",
      bgColor: "#E2FAEE",
      borderColor: "#8dd7cf",
      percentage: "",
    },
    {
      title: "Leader",
      status: "Why select this ?",
      ignoreStatus: "When to avoid ?",
      bgColor: "#E2FAEE",
      borderColor: "#8dd7cf",
      percentage: "",
    },
    {
      title: "Leader",
      status: "Why select this ?",
      ignoreStatus: "When to avoid ?",
      // bgColor: "#F4F8E4",
      // borderColor: "#ffe28c",
      bgColor: "#E2FAEE",
      borderColor: "#8dd7cf",
      percentage: "",
    },
    {
      title: "Leader",
      status: "Why select this ?",
      ignoreStatus: "When to avoid ?",
      bgColor: "#E2FAEE",
      borderColor: "#8dd7cf",
      percentage: "",
    },
  ];

  const OtherData = [
    {
      title: "Pioneer",
      status: "Why select this ?",
      ignoreStatus: "When to avoid ?",
      bgColor: "#E2FAEE",
      borderColor: "#8dd7cf",
      percentage: "",
    },
    {
      title: "Pioneer",
      status: "Why select this ?",
      ignoreStatus: "When to avoid ?",
      // bgColor: "#F4EFEB",
      // borderColor: "#e5929f",
      bgColor: "#E2FAEE",
      borderColor: "#8dd7cf",
      percentage: "",
    },
    {
      title: "Pioneer",
      status: "Why select this ?",
      ignoreStatus: "When to avoid ?",
      bgColor: "#E2FAEE",
      borderColor: "#8dd7cf",
      percentage: "",
    },
    {
      title: "Pioneer",
      status: "Why select this ?",
      ignoreStatus: "When to avoid ?",
      // bgColor: "#F4F8E4",
      // borderColor: "#ffe28c",
      bgColor: "#E2FAEE",
      borderColor: "#8dd7cf",
      percentage: "",
    },
    {
      title: "Pioneer",
      status: "Why select this ?",
      ignoreStatus: "When to avoid ?",
      bgColor: "#E2FAEE",
      borderColor: "#8dd7cf",
      percentage: "",
    },
  ];

  const [show, setShow] = useState(false);
  const [showPersonality, setShowPersonality] = useState(false);
  const handleClosePersonality = () => setShowPersonality(false);
  const [onePer, setOnePer] = useState([]);
  const handleShowPersonality = () => setShowPersonality(true);
  const [bigshow, setBigShow] = useState(false);
  const handleCloseBig = () => {
    setBigShow(false);
    setisTwo(false)
    setModalText('Unable to select')
  }
  const handleShowBig = () => setBigShow(true);

  const [showmodalPersonality, setShowmodalPersonality] = useState(false);
  const [applyButtonLoading, setApplyButtonLoading] = useState(false);
  const [applyTeoLoad, setApplyTwoLoad] = useState(false)
  const handleShowPersonalityPopup = (rec, per) => {
    if (rec === "N/A" || rec === null) {
      setOnePer([]);
      return;
    }
    setShowmodalPersonality(true);
    setOnePer(personalitiesList.filter((x) => x.personality?.trim() === rec?.trim()));
  };
  const handleClosePersonalityPopup = () => setShowmodalPersonality(false);


  const [section, setSection] = useState('')
  const [popupIndex, setPopupIndex] = useState(0)
  // ✅ Changed: popupIndex now stores `item.title` instead of index
  const [popupTitle, setPopupTitle] = useState(""); // ✅ Changed from popupIndex

  const handleClose = () => setShow(false);
  const handleShow = (section, title) => {
    console.log('jjj--', section, title)
    setSection(section)
    setPopupTitle(title)
    setShow(true)
  };

  const [itemToAdd, setItemToAdd] = useState({})


  function sleep(ms) {
    return new Promise(resolve => setTimeout(resolve, ms));
  }


  const handleSelectTwoPersonlity = (personality, index = null) => {


    if (index) {



      let person = personalitytwosel
      person[index] = itemToAdd

      setPersonalityTwo(person)

      handleCloseBig()

      return
    }




    let person = personalitytwosel

    if (personalitytwosel?.includes(personality)) {
      person = person?.filter((i) => i != personality)

    } else {
      if (personalitytwosel?.length > 3 && !isSuperVission) {


        let combinePopupData = person?.map((i) => ({ title: i }))
        setisTwo(true)
        setItemToAdd(personality)
        setCombinePopupData(combinePopupData)
        handleShowBig()
      } else {

        person = [...person, personality]
      }
    }

    setPersonalityTwo(person)



  }

  const toggleSelect = async (index, section, title, wholeItem, isSelected, deselectFromBig = false) => {



    if (!deselectFromBig) {
      setTitleToShowOnBehaviorModal(title)

    }
    const isRecommended = section === "recommended";
    const length = selectedRecommendedIndexes?.length + selectedOtherIndexes?.length

    if (length > 3 && !isSelected) {
      if (!deselectFromBig) {
        const itemToAdd = { ...wholeItem, section: section };

        const sectionToAdd = section;
        setItemToAdd(itemToAdd)
        console.log('itemToAdd--', itemToAdd, sectionToAdd)
      }

      const filteredRecom = recommendedData.filter(item => selectedRecommendedIndexes?.includes(item.title))?.map(item => ({
        ...item,
        section: 'recommended'
      }));
      const filteredOther = otherData.filter(item => selectedOtherIndexes?.includes(item.title))?.map(item => ({
        ...item,
        section: 'other'
      }));
      const combinePopupData = [...filteredRecom, ...filteredOther]


      setCombinePopupData(combinePopupData)

      handleShowBig()
      // return
    }



    if (title === titleToShowOnBehaviorModal) {
      if (isSelected) {
        setModalText('Unselected')
      } else {
        setModalText('Selected')
      }

    }


    if (deselectFromBig && isSelected) {



      //  const temp = combinePopupData.filter(item => item.title !== title)

      // 1. Find the index of the object to remove/replace
      const replaceIndex = combinePopupData.findIndex(item => item.title === title);
      const isAlreadyExist = combinePopupData.some(item => item.title === itemToAdd.title);

      if (!isAlreadyExist) {
        if (replaceIndex !== -1) {
          // 2. Make a copy of the original array
          const newArray = [...combinePopupData];

          // 3. Create your new object
          const newObject = { /* ... whatever properties ... */ };

          // 4. Replace 1 item at `replaceIndex` with `newObject`
          newArray.splice(replaceIndex, 1, itemToAdd);

          if (itemToAdd.section === 'recommended') {
            const titleTemp = itemToAdd.title;
            const arr = selectedRecommendedIndexes.push(titleTemp);
            // setSelectedRecommendedIndexes(arr)
            setModalText('Selected')
          } else {
            const titleTemp = itemToAdd.title;
            const arr = selectedOtherIndexes.push(titleTemp);
            console.log('arrr--', arr, titleTemp)
            setModalText('Selected')

            // setSelectedOtherIndexes(arr)
          }
          setCombinePopupData(newArray)
        }
      }

      handleCloseBig()

      //  setCombinePopupData(temp)
    }

    // const currentIndexes = isRecommended
    //   ? selectedRecommendedIndexes
    //   : selectedOtherIndexes;
    const currentIndexes = isRecommended
      ? selectedRecommendedIndexes
      : selectedOtherIndexes;

    // const alreadySelected = currentIndexes.includes(currentIndexes);
    // const updatedIndexes = alreadySelected
    //   ? currentIndexes.filter((i) => i !== index)
    //   : totalSelectedCount < MAX_SELECTION
    //   ? [...currentIndexes, index]
    //   : currentIndexes;

    const alreadySelected = currentIndexes.includes(title);

    const updatedIndexes = alreadySelected
      ? currentIndexes.filter((i) => i !== title)
      : totalSelectedCount < MAX_SELECTION
        ? [...currentIndexes, title]
        : currentIndexes;

    const temp = deselectFromBig ? [...updatedIndexes, itemToAdd.title] : updatedIndexes



    if (isRecommended) {

      setSelectedRecommendedIndexes(updatedIndexes);
    } else {
      setSelectedOtherIndexes(updatedIndexes);
    }

    // const temp = combinePopupData?.splice(index, 1)
    // console.log('temp99--', temp)
    // setCombinePopupData(temp)
    // if(deselectFromBig){
    //   await sleep(1000)
    //   handleCloseBig()
    // }

  };
  console.log('selectedRecommendedIndexes--', selectedRecommendedIndexes)
  console.log('selectedOtherIndexes--', selectedOtherIndexes)



  const toggleExpandStatus = (index, section, title) => {
    console.log('index--', index, title)
    handleShow(section, title)
    setExpandedStatusIndexes((prev) =>
      prev.includes(index) ? prev.filter((i) => i !== index) : [...prev, index]
    );
  };

  const toggleExpandIgnore = (index, section, title) => {
    handleShow(section, title)
    setExpandedIgnoreIndexes((prev) =>
      prev.includes(index) ? prev.filter((i) => i !== index) : [...prev, index]
    );
  };
  function truncateText(text, limit) {
    if (typeof text !== 'string') return '';
    if (text.length <= limit) return text;
    return text.slice(0, limit) + '...';
  }


  const deselectRenderCar = (item, index, section, title, isModal = false, deselectFromBig = false, isModalBig = false, isShowDes = true,) => {
    const isSelected =
      section === "recommended"
        ? selectedRecommendedIndexes.includes(title)
        : selectedOtherIndexes.includes(title)
    return (
      <div className='popup-behaviour-cards' onClick={(e) => isTwo ? handleSelectTwoPersonlity(title, index) : toggleSelect(index, section, item.title, item, isSelected, deselectFromBig)}> {item.title} </div>
    )
  }

  const renderCardVersionTwo = (item, index, section, title, isModal = false, deselectFromBig = false, isModalBig = false, isShowDes = true, isModifiedModal = false) => {


    const isSelected =
      section === "recommended"
        ? selectedRecommendedIndexes.includes(title)
        : selectedOtherIndexes.includes(title)
    // const isStatusExpanded = expandedStatusIndexes.includes(
    //   `${section}-${index}`
    // );
    // const isIgnoreExpanded = expandedIgnoreIndexes.includes(
    //   `${section}-${index}`
    // );
    const isStatusExpanded = expandedStatusIndexes.includes(`${section}-${title}`); // ✅ Changed from index
    const isIgnoreExpanded = expandedIgnoreIndexes.includes(`${section}-${title}`); // ✅ Changed from index
    const fullText = item?.status
    // "Primary Justification for why the behaviour has been included or excluded based on the primary recommendation. This should be of the just length and if longer should have a simple more link.";

    const shortText = truncateText(item?.status, 50)
    // "Primary Justification for why the behaviour has been included or excluded based on the primary recommendation. This should be of the just length... ";

    const fullTextAvoid = item?.ignoreStatus
    const shortTextAvoid = truncateText(item?.ignoreStatus, 50)
    const titleStyle = TITLE_COLOR_MAP[item.title] || {};
    const borderColor = titleStyle.color || "#FFF";
    const backgroundColor = titleStyle.bgColor || "#FFF";
    const firstTitle = section === 'recommended' ? 'Why was this recommended ?' : 'Conditions for Reconsideration'
    const secondtitle = section === 'recommended' ? 'When to ignore the recommendations' : 'Reasons for not selecting'
    console.log('popuptitle--', popupTitle)
    return (
      <div>
        <div closeButton className="custom-close-btn d-flex justify-content-between" style={{
          border: 'none',
          padding: '0',
          margin: '0',
          marginBottom: '8px'

        }}>


          <div className='d-flex align-items-center'>
            <h6 className="mb-0 mt-1" style={{ fontWeight: '600', fontSize: 'var(--font-size-h4)', marginRight: '4px' }}>
              {/* ✅ Changed from popupIndex to popupTitle */}
              {recommendedData.find(item => item.title === popupTitle)?.title || otherData.find(item => item.title === popupTitle)?.title}
            </h6>
            {section !== 'other' && (
              <span className='' style={{ display: 'inline' }}>
                <svg width="21" height="20" viewBox="0 0 21 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M10.2612 13.2966L9.545 14.9366C9.26958 15.567 8.3975 15.567 8.12208 14.9366L7.40583 13.2966C6.76875 11.837 5.62167 10.6753 4.19083 10.0403L2.22 9.16531C1.59333 8.88698 1.59333 7.97573 2.22 7.6974L4.12958 6.8499C5.59708 6.19865 6.76458 4.99365 7.39083 3.48448L8.11625 1.73656C8.38542 1.08781 9.28167 1.08781 9.55083 1.73656L10.2762 3.48448C10.9025 4.99365 12.07 6.19865 13.5375 6.8499L15.4471 7.6974C16.0737 7.97573 16.0737 8.88698 15.4471 9.16531L13.4762 10.0403C12.0454 10.6753 10.8983 11.8374 10.2612 13.2966Z" fill="#2196F3" />
                  <path d="M16.5096 18.02L16.3042 18.4912C16.1537 18.8362 15.6762 18.8362 15.5258 18.4912L15.3204 18.02C14.9542 17.18 14.2937 16.5112 13.4704 16.145L12.8371 15.8637C12.4946 15.7116 12.4946 15.2137 12.8371 15.0616L13.435 14.7958C14.2796 14.4204 14.9517 13.7271 15.3117 12.8583L15.5229 12.3491C15.67 11.9941 16.1608 11.9941 16.3079 12.3491L16.5192 12.8583C16.8792 13.7271 17.5512 14.4204 18.3958 14.7958L18.9937 15.0616C19.3362 15.2137 19.3362 15.7116 18.9937 15.8637L18.3604 16.145C17.5362 16.5112 16.8762 17.18 16.5096 18.02Z" fill="#7E57C2" />
                </svg>

              </span>
            )}

          </div>
          <div className='d-flex align-items-center ' style={{ gap: '24px' }}>
            <span className="select-label">
              <label className="switch">
                <input
                  type="checkbox"
                  checked={isSelected}
                  onChange={(e) => toggleSelect(index, section, item.title, item, isSelected, deselectFromBig)}
                // disabled={!isSelected && totalSelectedCount >= MAX_SELECTION}
                />
                <span className="slider round"></span>
              </label>
            </span>

            <span style={{ cursor: 'pointer' }} onClick={handleClose}><svg style={{ fontWeight: '400' }} width="15" height="15" viewBox="0 0 9 9" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M4.75659 5.39876L2.33993 7.81543C2.18715 7.96821 1.9927 8.0446 1.75659 8.0446C1.52048 8.0446 1.32604 7.96821 1.17326 7.81543C1.02048 7.66265 0.944092 7.46821 0.944092 7.2321C0.944092 6.99599 1.02048 6.80154 1.17326 6.64876L3.58993 4.2321L1.17326 1.83626C1.02048 1.68349 0.944092 1.48904 0.944092 1.25293C0.944092 1.01682 1.02048 0.822374 1.17326 0.669596C1.32604 0.516819 1.52048 0.44043 1.75659 0.44043C1.9927 0.44043 2.18715 0.516819 2.33993 0.669596L4.75659 3.08626L7.15243 0.669596C7.3052 0.516819 7.49965 0.44043 7.73576 0.44043C7.97187 0.44043 8.16631 0.516819 8.31909 0.669596C8.48576 0.836263 8.56909 1.03418 8.56909 1.26335C8.56909 1.49251 8.48576 1.68349 8.31909 1.83626L5.90243 4.2321L8.31909 6.64876C8.47187 6.80154 8.54826 6.99599 8.54826 7.2321C8.54826 7.46821 8.47187 7.66265 8.31909 7.81543C8.15243 7.9821 7.95451 8.06543 7.72534 8.06543C7.49618 8.06543 7.3052 7.9821 7.15243 7.81543L4.75659 5.39876Z" fill="#3A4B68" />
            </svg>
            </span>
          </div>
        </div>


        <div className='renderCardVersionTwo-grid' >
          <div className={`renderCardVersionTwo-main-div ${section !== 'other' ? 'green-border' : 'yellow-border'}`}>
            <div className='renderCardVersionTwo-title'>
              <div className='d-flex align-items-center'>
                {section !== 'other' ? (
                  <div style={{ marginRight: '4px', transform: 'translateY(-2px)' }}>
                    <svg width="13" height="13" viewBox="0 0 13 13" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <circle cx="6.11816" cy="6.80078" r="6" fill="#34D399" />
                    </svg>
                  </div>
                ) : (<div style={{ marginRight: '4px', transform: 'translateY(0px)' }}>
                  <img src={war} height={16} width={16} />
                </div>)}

                {firstTitle} </div>
            </div>
            <div className='renderCardVersionTwo-text'>
              {fullText}
            </div>
          </div>

          <div className={`renderCardVersionTwo-main-div   ${section === 'other' ? 'grid-row-start-1 green-border' : 'yellow-border'}`}>
            <div className='renderCardVersionTwo-title'>
              <div className='d-flex align-items-center'>
                {section !== 'other' ? (
                  <div style={{ marginRight: '4px', transform: 'translateY(0px)' }}>
                    <img src={war} height={16} width={16} />
                  </div>
                ) : (<div style={{ marginRight: '4px', transform: 'translateY(-2px)' }}>
                  <svg width="13" height="13" viewBox="0 0 13 13" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <circle cx="6.11816" cy="6.80078" r="6" fill="#34D399" />
                  </svg>
                </div>)}
                {secondtitle} </div>
            </div>
            <div className='renderCardVersionTwo-text'>
              {fullTextAvoid}
            </div>
          </div>

        </div>
      </div>
    )
  }


  const renderCard = (item, index, section, title, isDisabled = false, isModal = false, deselectFromBig = false, isModalBig = false, isShowDes = true, isModifiedModal = false) => {
    console.log('section--', section, title)
    console.log('selectedRecommendedIndexes3--', selectedRecommendedIndexes)


    const isSelected = isDisabled ? personalitytwosel.includes(title) :
      section === "recommended"
        ? selectedRecommendedIndexes.includes(title)
        : selectedOtherIndexes.includes(title)
    const isStatusExpanded = expandedStatusIndexes.includes(
      `${section}-${index}`
    );
    const isIgnoreExpanded = expandedIgnoreIndexes.includes(
      `${section}-${index}`
    );

    const fullText = item?.status
    // "Primary Justification for why the behaviour has been included or excluded based on the primary recommendation. This should be of the just length and if longer should have a simple more link.";

    const shortText = truncateText(item?.status, 50)
    // "Primary Justification for why the behaviour has been included or excluded based on the primary recommendation. This should be of the just length... ";

    const fullTextAvoid = item?.ignoreStatus
    const shortTextAvoid = truncateText(item?.ignoreStatus, 50)
    const titleStyle = TITLE_COLOR_MAP[item.title] || {};
    const borderColor = titleStyle.color || "#FFF";
    const backgroundColor = titleStyle.bgColor || "#FFF";
    const firstTitle = section === 'recommended' ? 'Why was this recommended ?' : 'Conditions for Reconsideration'
    const secondtitle = section === 'recommended' ? 'When to ignore the recommendations' : 'Reasons for not selecting'
    return (
      <>



        <div className={`${isModal ? 'col-md-12' : 'col-md-12'}`} key={index} style={{ marginBottom: '8px' }} >

          <div
            className={`card-box ${isModal ? 'h-100' : 'min-height'}  ${(!isSelected && totalSelectedCount >= MAX_SELECTION) ? 'disabled--' : ''}`}
            style={{
              backgroundColor: isSelected ? backgroundColor : "#F4F5F7",
              border: `0.3px solid #e6e6e6`,
              // border: '1px solid white',
              // borderLeft: "7px solid #34D399",
              borderLeft: `7px solid ${borderColor}`,

              cursor: "pointer",
            }}
          >

            {/* <div className='card-box-star'>
            {section === 'recommended' && (
              <img src={recomented} style={{ height: '20px', width: '20px' }} />
            )}

          </div> */}
            <div className="card-header d-flex justify-content-between align-items-center">
              <h4
                style={{
                  fontSize: "var(--font-size-base) !important",
                  marginBottom:'0',
                  fontWeight: "normal",
                }}
                className="font-color-text"
              >
                {item.title}  <span className="be-4">{item.percentage}</span>
                {!modal && (

                  section === 'recommended' && (

                    <span className=''>
                      <svg width="21" height="20" viewBox="0 0 21 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M10.2612 13.2966L9.545 14.9366C9.26958 15.567 8.3975 15.567 8.12208 14.9366L7.40583 13.2966C6.76875 11.837 5.62167 10.6753 4.19083 10.0403L2.22 9.16531C1.59333 8.88698 1.59333 7.97573 2.22 7.6974L4.12958 6.8499C5.59708 6.19865 6.76458 4.99365 7.39083 3.48448L8.11625 1.73656C8.38542 1.08781 9.28167 1.08781 9.55083 1.73656L10.2762 3.48448C10.9025 4.99365 12.07 6.19865 13.5375 6.8499L15.4471 7.6974C16.0737 7.97573 16.0737 8.88698 15.4471 9.16531L13.4762 10.0403C12.0454 10.6753 10.8983 11.8374 10.2612 13.2966Z" fill="#2196F3" />
                        <path d="M16.5096 18.02L16.3042 18.4912C16.1537 18.8362 15.6762 18.8362 15.5258 18.4912L15.3204 18.02C14.9542 17.18 14.2937 16.5112 13.4704 16.145L12.8371 15.8637C12.4946 15.7116 12.4946 15.2137 12.8371 15.0616L13.435 14.7958C14.2796 14.4204 14.9517 13.7271 15.3117 12.8583L15.5229 12.3491C15.67 11.9941 16.1608 11.9941 16.3079 12.3491L16.5192 12.8583C16.8792 13.7271 17.5512 14.4204 18.3958 14.7958L18.9937 15.0616C19.3362 15.2137 19.3362 15.7116 18.9937 15.8637L18.3604 16.145C17.5362 16.5112 16.8762 17.18 16.5096 18.02Z" fill="#7E57C2" />
                      </svg>

                    </span>

                  )
                )}
              </h4>

              <span className="select-label">
                <label className="switch">
                  <input
                    type="checkbox"
                    checked={isSelected}
                    onChange={(e) => { isDisabled ? handleSelectTwoPersonlity(item?.title) : toggleSelect(index, section, item.title, item, isSelected, deselectFromBig) }}
                  // disabled={!isSelected && totalSelectedCount >= MAX_SELECTION}
                  />
                  <span className="slider round"></span>
                </label>
              </span>
            </div>
            {!modal && (
              isShowDes &&
              <div className='combine-section-behavior-card' >
                {
                  isShowDes &&

                  <div className="">
                    <p
                      className="section-title why-select-heading"

                    >
                      {/* <img src={like} width={16} height={16} /> */}
                      {firstTitle}
                    </p>
                    <p
                      style={{
                        color: "#68758B",
                        fontSize: "var(--font-size-base)",
                        fontWeight: 500,
                        letterSpacing: "0.5px",
                        lineHeight: "16px",
                        marginBottom: '0'
                      }}
                    >
                      {/* {isStatusExpanded  ? fullText : shortText} */}
                      {isModal ? fullText : shortText}
                      <span
                        className="more"
                        style={{ color: "blue", cursor: "pointer" }}
                        onClick={() => toggleExpandStatus(`${section}-${index}`, section, item?.title)}
                      >
                        {/* {isStatusExpanded ? "less" : "more"} */}
                        {isModal ? "" : "more"}
                      </span>
                    </p>
                  </div>
                }
                {!isModalBig && (
                  <div className={`${section === 'other' ? 'grid-row-start-1' : ''}`} >
                    <p
                      className="section-title why-select-heading"

                    >
                      {/* <img src={war} width={16} height={16} /> */}
                      {/* {item.ignoreStatus} */}
                      {secondtitle}
                    </p>
                    <p
                      style={{
                        color: "#68758B",
                        fontSize: "var(--font-size-base)",
                        fontWeight: 500,
                        letterSpacing: "0.5px",
                        lineHeight: "16px",
                        marginBottom: '0'
                      }}
                    >
                      {/* {isIgnoreExpanded ? fullTextAvoid : shortTextAvoid} */}
                      {isModal ? fullTextAvoid : shortTextAvoid}
                      <span
                        className="more"
                        style={{ color: "blue", cursor: "pointer" }}
                        onClick={() => toggleExpandIgnore(`${section}-${index}`, section, item?.title)}
                      >
                        {/* {isIgnoreExpanded ? "less" : "more"} */}
                        {isModal ? "" : "more"}

                      </span>
                    </p>
                  </div>
                )}
              </div>
            )}
          </div>
        </div>


      </>
    );


  };




  ///////////////////////////////////////////////////////////////////////////////////////////////////////
  console.log('formData--', formData)
  const mergeBehaviorData = (apiData) => {
    console.log('apidata-->', apiData)
    const recommended = apiData.selected.map((item, i) => ({
      ...behaviorData[i % behaviorData.length], // keep UI design (title, icon, bg color)
      title: item.title,
      // status: `${item.reasonForSelection} ${item.comparison}`, // "Why select this?"
      status: `${(item.reasonForSelection || item.conditionForReconsideration)}  ${item.comparison}  `,
      ignoreStatus: item.conditionForReconsideration, // "When to avoid?"
    }));

    const titleReco = recommended?.map(item => item.title)
    if (!modal) {
      setSelectedRecommendedIndexes(titleReco)
    }
    if (modal && selectedBehaviorFromApi) {

      const temp = Object.values(selectedBehaviorFromApi)
      // setSelectedRecommendedIndexes( temp)
      // console.log('selectedBehaviorFromApi--', selectedBehaviorFromApi, temp)
      const recommendedTitles = new Set([
        'Accuracy',
        'Cooperativeness',
        'Efficiency',
        'Self Confidence'
      ]);

      const recommended = [];
      const others = [];

      temp?.forEach(item => {
        if (recommendedTitles?.has(item)) {
          recommended?.push(item);
        } else {
          others?.push(item);
        }
      });

      setSelectedRecommendedIndexes(recommended);
      setSelectedOtherIndexes(others);


      setPersonalityTwo(isSuperVission ? [] : selectedBehavoiurTwo?.length > 0 ? selectedBehavoiurTwo : [])


    }

    const others = apiData.nonSelected.map((item, i) => ({
      ...OtherData[i % OtherData.length], // keep UI design
      title: item.title,
      // status: `${item.conditionForReconsideration} ${item.comparison}`, // "Why select this?"
      status: `${item.reasonForSelection || item.conditionForReconsideration} ${item.comparison}`,
      ignoreStatus: item.reasonForNonSelection || item.conditionForReconsideration, // "When to avoid?"
    }));

    const selectedByUser = apiData.selectedByUser.map((item, i) => ({
      ...OtherData[i % OtherData.length], // keep UI design
      title: item.title,
      // status: `${item.conditionForReconsideration} ${item.comparison}`, // "Why select this?"
      status: `${item.reasonForSelection || item.conditionForReconsideration}`,
      ignoreStatus: item.reasonForNonSelection || item.conditionForReconsideration, // "When to avoid?"
    }));

    return { selectedByUser, recommended, others };
  };

  const [recommendedData, setRecommendedData] = useState([]);
  const [selectedByUser, setSelectedByUser] = useState([]);
  const [otherData, setOtherData] = useState([]);

  const StaticBehaviorsDataApi = {
    "selectedByUser": [
      {
        "title": "Accuracy",
        "behaviourCode": "A",
        "reasonForSelection": "In a technical role like a React Developer, precision in code quality is crucial, especially when developing user interface components and optimizing them for performance. Although faster delivery is prioritized, maintaining accuracy ensures fewer bugs and better application stability, aligning with the high priority given to bug fixes.",
        "conditionForReconsideration": "If the role shifts to a more exploratory or prototype-focused position where rapid iteration is more valued than precision, Accuracy might become less critical."
      },
      {
        "title": "Cooperativeness",
        "behaviourCode": "B",
        "reasonForSelection": "Cooperativeness is essential as the role involves collaborating with cross-functional teams to define, design, and ship new features. This collaboration is integral to the job, as indicated by the daily interaction with other departments.",
        "conditionForReconsideration": "If the role becomes more isolated or independent, with less need for team interaction, Cooperativeness might be less emphasized."
      },
      {
        "title": "Efficiency",
        "behaviourCode": "C",
        "reasonForSelection": "Efficiency is critical in a fast-paced environment where rapid feature delivery is prioritized. The ability to manage state effectively and optimize components for performance aligns with the need for efficient work processes.",
        "conditionForReconsideration": "If the pace of work slows down or if there is a shift towards more thorough, deliberate development processes, Efficiency might be less prioritized."
      },
      {
        "title": "Self Confidence",
        "behaviourCode": "I",
        "reasonForSelection": "Self Confidence is important as developers have full ownership of technical decision-making with minimal oversight. Confidence in one's technical skills and decisions is crucial for effective performance in this autonomous environment.",
        "conditionForReconsideration": "If the role becomes more supervised or if decision-making is more collaborative, the need for Self Confidence might decrease."
      }
    ],
    "selected": [
      {
        "title": "Accuracy",
        "behaviourCode": "A",
        "reasonForSelection": "In a technical role like a React Developer, precision in code quality is crucial, especially when developing user interface components and optimizing them for performance. Although faster delivery is prioritized, maintaining accuracy ensures fewer bugs and better application stability, aligning with the high priority given to bug fixes.",
        "conditionForReconsideration": "If the role shifts to a more exploratory or prototype-focused position where rapid iteration is more valued than precision, Accuracy might become less critical."
      },
      {
        "title": "Cooperativeness",
        "behaviourCode": "B",
        "reasonForSelection": "Cooperativeness is essential as the role involves collaborating with cross-functional teams to define, design, and ship new features. This collaboration is integral to the job, as indicated by the daily interaction with other departments.",
        "conditionForReconsideration": "If the role becomes more isolated or independent, with less need for team interaction, Cooperativeness might be less emphasized."
      },
      {
        "title": "Efficiency",
        "behaviourCode": "C",
        "reasonForSelection": "Efficiency is critical in a fast-paced environment where rapid feature delivery is prioritized. The ability to manage state effectively and optimize components for performance aligns with the need for efficient work processes.",
        "conditionForReconsideration": "If the pace of work slows down or if there is a shift towards more thorough, deliberate development processes, Efficiency might be less prioritized."
      },
      {
        "title": "Self Confidence",
        "behaviourCode": "I",
        "reasonForSelection": "Self Confidence is important as developers have full ownership of technical decision-making with minimal oversight. Confidence in one's technical skills and decisions is crucial for effective performance in this autonomous environment.",
        "conditionForReconsideration": "If the role becomes more supervised or if decision-making is more collaborative, the need for Self Confidence might decrease."
      }
    ],
    "nonSelected": [
      {
        "title": "Enthusiasm",
        "behaviourCode": "D",
        "reasonForNonSelection": "Enthusiasm, while beneficial, is not as critical as other behaviors for this role. The job focuses more on technical skills and efficient collaboration rather than the level of enthusiasm.",
        "conditionForReconsideration": "If the company culture shifts to prioritize employee morale and engagement over technical output, Enthusiasm might become more important."
      },
      {
        "title": "Friendliness",
        "behaviourCode": "E",
        "reasonForNonSelection": "Friendliness is less critical compared to Cooperativeness, as the role requires effective collaboration rather than just being friendly. The focus is on achieving technical goals through teamwork.",
        "conditionForReconsideration": "If the role involves more customer interaction or client-facing duties, Friendliness might become more relevant."
      },
      {
        "title": "Independence",
        "behaviourCode": "F",
        "reasonForNonSelection": "Independence is less emphasized because while autonomy in decision-making is present, the role requires collaboration and teamwork, making Cooperativeness more critical.",
        "conditionForReconsideration": "If the role becomes more isolated with less team interaction, Independence might become more important."
      },
      {
        "title": "Patience",
        "behaviourCode": "G",
        "reasonForNonSelection": "Patience is less critical in this fast-paced environment where rapid delivery is prioritized. The role requires quick adaptation to changes rather than patient deliberation.",
        "conditionForReconsideration": "If the work environment becomes more stable with fewer urgent changes, Patience might become more valuable."
      },
      {
        "title": "Persistence",
        "behaviourCode": "H",
        "reasonForNonSelection": "Persistence, while valuable, is less emphasized compared to Efficiency and Accuracy. The role requires quick adaptation and precise execution rather than prolonged effort.",
        "conditionForReconsideration": "If the role involves more long-term projects with extended timelines, Persistence might become more important."
      },
      {
        "title": "Self Motivation",
        "behaviourCode": "J",
        "reasonForNonSelection": "Self Motivation is less critical as the role involves structured collaboration and defined tasks, with less emphasis on initiating improvements independently.",
        "conditionForReconsideration": "If the role shifts to require more initiative and self-driven projects, Self Motivation might become more important."
      },
      {
        "title": "Sensitivity",
        "behaviourCode": "K",
        "reasonForNonSelection": "Sensitivity is less critical as the role focuses more on technical skills and collaboration rather than emotional intelligence or interpersonal sensitivity.",
        "conditionForReconsideration": "If the role involves more client interaction or requires managing team dynamics, Sensitivity might become more important."
      },
      {
        "title": "Thoughtfulness",
        "behaviourCode": "L",
        "reasonForNonSelection": "Thoughtfulness is less emphasized compared to Efficiency and Accuracy, as the role requires quick decision-making and precise execution rather than prolonged contemplation.",
        "conditionForReconsideration": "If the role shifts to involve more strategic planning or long-term project development, Thoughtfulness might become more important."
      }
    ]
  }
  useEffect(() => {
    console.log('this has ran')
    async function fetchBehaviorData() {
      console.log('modal--', modal)
      const data = modal ? StaticBehaviorsDataApi : formData.behaviorsDataApi
      const { selectedByUser, recommended, others } = mergeBehaviorData(data);
      setRecommendedData(recommended);
      setOtherData(others);
      setSelectedByUser(selectedByUser)
    }
    // if(formData.behaviorsDataApi.length > 0) {



    fetchBehaviorData();
    // }
  }, [formData.behaviorsDataApi]);

  // Usage
  // const { recommended, others } = mergeBehaviorData(formData.behaviorsDataApi);


  console.log('setSelectedByUser--', selectedByUser)

  const [lengthOfSelected, setLengthOfSelected] = useState(0)
  async function updateSelectedBehaviors(
    recommendedIndexes,
    otherIndexes,
    recommendedData,
    otherData,
    behaviorsDataApi
  ) {
    if (
      !Array.isArray(recommendedIndexes) ||
      !Array.isArray(otherIndexes) ||
      !Array.isArray(recommendedData) ||
      !Array.isArray(otherData) ||
      typeof behaviorsDataApi !== 'object'
    ) {
      console.error('Invalid input types');
      return;
    }
    const behaviorsDataApiCopy = { ...behaviorsDataApi }
    // Step 2: Extract recommended titles
    //   const recommendedTitles = recommendedIndexes
    //     .map(index => recommendedData[index]?.title)
    //     .filter(Boolean); // Remove undefined/null
    // 
    //   // Step 3: Extract other titles
    //   const otherTitles = otherIndexes
    //     .map(index => otherData[index]?.title)
    //     .filter(Boolean);

    const recommendedTitles = [...new Set(recommendedIndexes.filter(Boolean))];
    const otherTitles = [...new Set(otherIndexes.filter(Boolean))];


    //   // Step 4: Filter selected behaviors that match recommended titles
    //   const selectedRecommendedBehaviours = behaviorsDataApiCopy.selected.filter(behaviour =>
    //     recommendedTitles.includes(behaviour.title)
    //   );
    // 
    //   // Step 5: Filter nonSelected behaviors that match other titles
    //   const selectedOtherBehaviours = behaviorsDataApiCopy.nonSelected.filter(behaviour =>
    //     otherTitles.includes(behaviour.title)
    //   );

    // Step 4: Filter selected behaviors that match recommended titles
    const selectedRecommendedBehaviours = behaviorsDataApiCopy.selected.filter(behaviour =>
      recommendedTitles.includes(behaviour.title)
    );

    // Store remaining (non-recommended) selected behaviours
    const remainingSelectedBehaviours = behaviorsDataApiCopy.selected.filter(behaviour =>
      !recommendedTitles.includes(behaviour.title)
    );

    console.log('remainingSelectedBehaviours--', remainingSelectedBehaviours)
    // Step 5: Filter nonSelected behaviors that match other titles
    const selectedOtherBehaviours = behaviorsDataApiCopy.nonSelected.filter(behaviour =>
      otherTitles.includes(behaviour.title)
    );

    // Remove matched other behaviors from nonSelected
    // const filteredNonSelected = behaviorsDataApiCopy.nonSelected.filter(behaviour =>
    //   !otherTitles.includes(behaviour.title)
    // );

    // Prepend remaining selected behaviours to the cleaned nonSelected
    // behaviorsDataApiCopy.nonSelected = [...remainingSelectedBehaviours, ...filteredNonSelected];


    // Step 6: Merge both selected sets
    const selectedAllBehaviours = [
      ...selectedRecommendedBehaviours,
      ...selectedOtherBehaviours
    ];
    const lengthOfSelectedTemp = selectedAllBehaviours.length
    console.log('lengthOfSelectedTemp-->', lengthOfSelectedTemp, selectedAllBehaviours)
    setLengthOfSelected(lengthOfSelectedTemp)

    // Step 7: Replace behaviorsDataApi.selected with new merged list
    const temp = behaviorsDataApiCopy.selectedByUser = selectedAllBehaviours;
    console.log('temp-->', temp)
    const updatedBehaviorsDataApi = {
      selectedByUser: [...temp],
      selected: behaviorsDataApiCopy.selected, // deep copy selected
      nonSelected: behaviorsDataApiCopy.nonSelected,
    };

    console.log("updatedBehaviorsDataApi--", updatedBehaviorsDataApi)
    dispatch(updateFormField({
      field: 'behaviorsDataApi',
      value: updatedBehaviorsDataApi,
    }));
  }


  const handleApplyClick = async () => {
    const length = selectedRecommendedIndexes?.length + selectedOtherIndexes?.length
    if (modal) {
      if (length < 4) {
        toastMsg("error", 'Please select Match 1 of 4 Behaviors');
      } else {
        await getPersonalityMatches(true)

        // await handleCloseBehaviour()

        // calucluatePersonalityPercentage()
      }
      return
    }


    if (length < 4) {
      toastMsg("error", 'Please select 4 behaviors');
    } else {
      await updateSelectedBehaviors(selectedRecommendedIndexes, selectedOtherIndexes, recommendedData, otherData, formData.behaviorsDataApi)
      dispatch(updateFormField({ field: 'isTryToChangeBehaviour', value: true }))
      dispatch(updateFormField({ field: 'step', value: 3 }));
      dispatch(updateFormField({ field: 'generateBehaviourCompleteFlag', value: true }));
      navigate("/JobDescription")
    }
  }


  async function getPersonalityMatches(ranFromApply = false, isTwo = false) {
    // setIdentifiedBehaviour([]);
    if (ranFromApply) {
      if (modal && !isTwo) setApplyButtonLoading(true)
    } else {
      if (isTwo) {
        setIsLoadingTwo(true)
      } else {
        setCheckPersonalityLoading(true);
      }

    }

    let payload = {}

    const behaviorPayload = [...selectedRecommendedIndexes, ...selectedOtherIndexes]
    if (isTwo) {

      let notDuplicata = [...personalitytwosel]

      behaviorPayload?.forEach((item) => {
        if (!notDuplicata.includes(item)) {
          notDuplicata.push(item)
        }
      })


      payload = {
        b1: notDuplicata[0] || behaviorPayload[0],
        b2: notDuplicata[1] || behaviorPayload[1],
        b3: notDuplicata[2] || behaviorPayload[2],
        b4: notDuplicata[3] || behaviorPayload[3],
      }

    } else {


      if (!behaviorPayload[0]?.length) return
      payload = {

        b1: behaviorPayload[0],
        b2: behaviorPayload[1],
        b3: behaviorPayload[2],
        b4: behaviorPayload[3],

      };
    }



    try {
      const response = await fetchPOST(
        ApiConfig.POST_GET_PERSONALITY_MATCHES,
        payload
      );

      if (response.succeded) {
        setcheckPersonalityData(response.response)
        if (modal) {
          if (isTwo) {
            if (!isSuperVission) {
              setSelectedBehavoiurTwo(Object.values(payload))
              setPersonalityMatchTwo(response?.response)

            }
            setApplyTwoLoad(false)
            setIsLoadingTwo(false)

          } else {
            setSelectedBehaviorFromApi(payload)
            setPersonalityMatchingData(response.response)
          }

        }
      }
    } catch (err) {

      console.error("Error submitting form:", err.message);
      toastMsg("error", err?.message);
    } finally {
      setCheckPersonalityLoading(false);
      setApplyButtonLoading(false)
    }
  }

  const traits = [
    { name: "Steadiness", color: "#4cd6b9" },
    { name: "Influence", color: "#b6a1fb" },
    { name: "Dominance", color: "#f17d8b" },
    { name: "Conscientiousness", color: "#fbc43c" },
  ];
  const skillSections = [
    {
      data: recommendedData,
      type: "recommended",
      title: "Recommended",
      rowGap: "24px",
    },
    {
      data: otherData,
      type: "other",
      title: "Others",
      rowGap: "8px",
    },
  ];

  function groupCardsByTitles(data, groups) {
    console.log('my_dataa--', data)
    console.log('my_group--', groups)
    return groups.map((group) => {
      const matchedCards = data.filter((item) =>
        group.titles.includes(item.title)
      );
      return {
        groupName: group.groupName,
        cards: matchedCards
      };
    });
  }

  // console.log("my_combine_array--",[...recommendedData, ...otherData])
  const groupedByTrait = traits.map((trait) => {
    return {
      ...trait,
      cards: [...recommendedData, ...otherData].filter((card) =>


        COLOR_TITLE_GROUPS.find(
          (group) =>


            group.color.toLowerCase() == trait.color
            &&
            group.titles.includes(card.title)
        )

      ),

    };
  });




  // 1. Flatten all section.data into one array
  const allCards = skillSections.flatMap(section =>
    section.data.map(card => ({ ...card, sectionType: section.type }))
  );

  // 2. Group all cards once
  const groupedData = groupCardsByTitles(allCards, COLOR_TITLE_GROUPS);

  return (
    <div
      style={{ backgroundColor: "#F2F4F7" }}
      className={`canLisContentWrap ${!openSideBar ? "fullwidth" : null}`}
    >


      <div className="t-wrapper-div---"
        style={{ padding: "10px" }}>
        {
          !isSuperVission &&
          <div style={{ backgroundColor: "#F2F4F7" }}>
            <div className="t-wrapper-div" style={{ padding: modal ? "10px" : "0", margin: modal ? "0" : '' }}>
              <main className="flex-1 p-10 bg-white" style={{ padding: "10px" }}>
                <div className='sticky-position-for-behavior-color-code'>
                  <h4>Match </h4>
                  <div className={`behavior-page-header-grid ${modal ? "behavior-page-header-grid--modal" : ""}`}>
                    {/* <div className="col-md-12"> */}

                    <div className="col-md-3--"

                      style={{ display: "flex--", gap: "8px", alignItems: "center", justifySelf: 'start' }}
                    >
                      <div style={{
                        display: "flex--",
                        alignItems: 'center', gap: '16px'
                      }}>
                        <div style={{
                          display: "flex",
                          alignItems: 'center', gap: '16px'
                        }} >
                          <h4
                            style={{
                              fontSize: "var(--font-size-h4)",
                              letterSpacing: "0.15px",
                              fontWeight: 500,
                              display: "contents",

                            }}
                            className="font-color-text"
                          >
                            Please Select 4 behaviors
                          </h4>
                          <div
                            style={{
                              backgroundColor: 'var(--brand-primary)',
                              fontSize: "var(--font-size-base)",
                              color: "white",
                              padding: "6px 16px",
                              borderRadius: "16px",
                            }}
                          >
                            {totalSelectedCount}/4
                          </div>
                        </div>

                      </div>
                      {/* <div>
                      <p
                        style={{
                          fontSize: "var(--font-size-base)",
                          fontFamily: "Roboto",
                          letterSpacing: "0.5px",
                          fontWeight: '400',
                          color: "#3a4b68"
                        }}
                      >
                        Toggle the Switch on and off to select and unselect the
                        behaviors
                      </p>
                    </div> */}
                    </div>

                    <div className="col-md-3--" style={{ display: 'flex', gap: "16px", justifySelf: "start", alignSelf: 'center' }}>
                      <div className='recommeded-flex-box'>

                        {!modal && (
                          <>
                            {/* <img src={recomented} style={{ width: '20px', height: '20px' }} /> */}
                            <span className='' style={{ display: 'inline' }}>
                              <svg width="21" height="20" viewBox="0 0 21 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M10.2612 13.2966L9.545 14.9366C9.26958 15.567 8.3975 15.567 8.12208 14.9366L7.40583 13.2966C6.76875 11.837 5.62167 10.6753 4.19083 10.0403L2.22 9.16531C1.59333 8.88698 1.59333 7.97573 2.22 7.6974L4.12958 6.8499C5.59708 6.19865 6.76458 4.99365 7.39083 3.48448L8.11625 1.73656C8.38542 1.08781 9.28167 1.08781 9.55083 1.73656L10.2762 3.48448C10.9025 4.99365 12.07 6.19865 13.5375 6.8499L15.4471 7.6974C16.0737 7.97573 16.0737 8.88698 15.4471 9.16531L13.4762 10.0403C12.0454 10.6753 10.8983 11.8374 10.2612 13.2966Z" fill="#2196F3" />
                                <path d="M16.5096 18.02L16.3042 18.4912C16.1537 18.8362 15.6762 18.8362 15.5258 18.4912L15.3204 18.02C14.9542 17.18 14.2937 16.5112 13.4704 16.145L12.8371 15.8637C12.4946 15.7116 12.4946 15.2137 12.8371 15.0616L13.435 14.7958C14.2796 14.4204 14.9517 13.7271 15.3117 12.8583L15.5229 12.3491C15.67 11.9941 16.1608 11.9941 16.3079 12.3491L16.5192 12.8583C16.8792 13.7271 17.5512 14.4204 18.3958 14.7958L18.9937 15.0616C19.3362 15.2137 19.3362 15.7116 18.9937 15.8637L18.3604 16.145C17.5362 16.5112 16.8762 17.18 16.5096 18.02Z" fill="#7E57C2" />
                              </svg>

                            </span>
                          </>
                        )}


                        {!modal && (
                          <p className='my-header-text'>
                            Behaviors recommended by LYWO's AI
                          </p>
                        )}
                      </div>
                      <div className='recommeded-flex-box'>
                        <div className='' style={{ transform: 'translateY(-2px)' }}>
                          <svg width="21" height="12" viewBox="0 0 21 12" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <g clip-path="url(#clip0_243_3914)">
                              <rect x="0.793945" width="20" height="12" rx="6" fill="#34C759" />
                              <g filter="url(#filter0_ddd_243_3914)">
                                <rect x="9.70703" y="0.769531" width="10" height="10" rx="5" fill="white" />
                              </g>
                            </g>
                            <defs>
                              <filter id="filter0_ddd_243_3914" x="1.70703" y="-4.23047" width="26" height="26" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
                                <feFlood flood-opacity="0" result="BackgroundImageFix" />
                                <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha" />
                                <feOffset dy="3" />
                                <feGaussianBlur stdDeviation="0.5" />
                                <feComposite in2="hardAlpha" operator="out" />
                                <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.06 0" />
                                <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_243_3914" />
                                <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha" />
                                <feOffset dy="3" />
                                <feGaussianBlur stdDeviation="4" />
                                <feComposite in2="hardAlpha" operator="out" />
                                <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0" />
                                <feBlend mode="normal" in2="effect1_dropShadow_243_3914" result="effect2_dropShadow_243_3914" />
                                <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha" />
                                <feMorphology radius="1" operator="dilate" in="SourceAlpha" result="effect3_dropShadow_243_3914" />
                                <feOffset />
                                <feComposite in2="hardAlpha" operator="out" />
                                <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.04 0" />
                                <feBlend mode="normal" in2="effect2_dropShadow_243_3914" result="effect3_dropShadow_243_3914" />
                                <feBlend mode="normal" in="SourceGraphic" in2="effect3_dropShadow_243_3914" result="shape" />
                              </filter>
                              <clipPath id="clip0_243_3914">
                                <rect x="0.793945" width="20" height="12" rx="6" fill="white" />
                              </clipPath>
                            </defs>
                          </svg>


                        </div>
                        <p className='my-header-text'>
                          Selected behaviors
                        </p>
                      </div>
                    </div>

                    {/* <div className='col-md-3--' >
                    <div className="be-p-1 ">
                      <p className="be-2 margin-between-same-section color-group-box"
                        style={{ color: "#3a4b68" }}
                      >
                        The colour of the box explains which category the behavior
                        belongs to
                      </p>
                      <div
                        style={{
                          display: "flex",
                          gap: "8px",
                          alignItems: "center",
                          flexWrap: "wrap",
                        }}
                      >
                        <div
                          style={{ display: "flex", alignItems: "center", gap: "6px" }}
                        >
                          <div
                            style={{
                              width: "12px",
                              height: "12px",
                              backgroundColor: "#4cd6b9",
                              borderRadius: "2px",
                            }}
                          ></div>
                          <span className="be-2 color-group-box font-color-text" >Steadiness</span>
                        </div>
                        <div
                          style={{ display: "flex", alignItems: "center", gap: "6px" }}
                        >
                          <div
                            style={{
                              width: "12px",
                              height: "12px",
                              backgroundColor: "#b6a1fb",
                              borderRadius: "2px",
                            }}
                          ></div>
                          <span className="be-2 color-group-box font-color-text">Influence</span>
                        </div>
                        <div
                          style={{ display: "flex", alignItems: "center", gap: "6px" }}
                        >
                          <div
                            style={{
                              width: "12px",
                              height: "12px",
                              backgroundColor: "#f17d8b",
                              borderRadius: "2px",
                            }}
                          ></div>
                          <span className="be-2 color-group-box font-color-text">Dominance</span>
                        </div>
                        <div
                          style={{ display: "flex", alignItems: "center", gap: "6px" }}
                        >
                          <div
                            style={{
                              width: "12px",
                              height: "12px",
                              backgroundColor: "#fbc43c",
                              borderRadius: "2px",
                            }}
                          ></div>
                          <span className="be-2 color-group-box font-color-text">Conscientiousness</span>
                        </div>
                      </div>
                    </div>

                  </div> */}

                    <div className="col-md-3-- " style={{ paddingTop: '' }}>

                      <div style={{ display: "flex", justifyContent: "flex-end", gap: '10px' }}>
                        <div className="no-print ">
                          <CustomButton
                            title="Check Personalities"
                            iconToLeft={User}
                            isLoading={checkPersonalityLoading}
                            disabled={checkPersonalityLoading}
                            buttonType="secondary"
                            fontSize='11px'
                            forChechPer ={true}
                            handleClick={async () => {

                              const length = selectedRecommendedIndexes?.length + selectedOtherIndexes?.length

                              if (length < 4) {
                                toastMsg("error", 'Please select 4 behaviors');
                                return
                              }


                              await getPersonalityMatches()
                              handleShowPersonality()
                            }}
                          />

                        </div>
                        {!modal && (
                          <div className="no-print ">
                            <CustomButton
                              title="Re-answers Questions"
                              isLoading={false}
                              iconToLeft={Refresh}
                              buttonType="secondary"
                              fontSize='11px'
                              handleClick={() => {
                                dispatch(updateFormField({ field: 'step', value: 2 }));
                                navigate("/JobDescription")
                              }}
                            />

                          </div>
                        )}
                        {/* <div className="no-print ">
              <CustomButton
                title="Close"
                isLoading={false}
                buttonType="secondary"
                handleClick={() => {
                  dispatch(updateFormField({ field: 'step', value: 3 }));
                   navigate("/JobDescription")}}
              />
            
            </div> */}
                        {
                          modal &&

                          <div className="no-print ">
                            <CustomButton
                              title="Apply"
                              type="button"
                              isLoading={applyButtonLoading}
                              isDisabled={applyButtonLoading}
                              fontSize='11px'
                              buttonType="primary"
                              handleClick={handleApplyClick}
                            />
                          </div>
                        }
                      </div>
                    </div>
                    {/* </div> */}
                  </div>
                  {/* <div className="col-md-12">
              <div className="row">
                <p
                  style={{
                    fontSize: "var(--font-size-base)",
                    fontFamily: "Roboto",
                    letterSpacing: "0.5px",
                  }}
                >
                  Toggle the Switch on and off to select and unselect the
                  behaviors
                </p>
              </div>
            </div> */}
                  {console.log('recom-->', recommendedData)}
                  {console.log('others-->', otherData)}

                </div>
                <div className='scroll-div-behavior'>
                  <div className="mt-3-- be-3">Behaviors</div>
                  <div className="col-md-12 mt-2">
                    <div className='row'
                      style={{
                        display: "flex",
                        rowGap: "24px",
                        // alignItems: "center",
                        // flexWrap: "wrap",
                      }}
                    >

                      {traits.map((trait, index) => (
                        <div
                          className="col-md-3"
                          key={index}
                          style={{ display: "flex", alignItems: "center", gap: "6px", marginBottom: '3px' }}
                        >
                          <div
                            style={{
                              width: "12px",
                              height: "12px",
                              backgroundColor: trait.color,
                              borderRadius: "2px",
                            }}
                          ></div>
                          <span className="be-2 color-group-box font-color-text">{trait.name}</span>
                        </div>
                      ))}




                    </div>


                    {console.log('skillSections--', skillSections)}
                    {console.log('groupedData--', groupedData)}
                    <div className="row">
                      {groupedData
                        .filter(group => group.cards.length > 0)
                        .map((group, groupIndex) => (
                          <div className="col-md-3" key={groupIndex}>

                            {group.cards.map((item, index) =>
                              renderCard(item, index, item.sectionType, item.title)
                            )}
                          </div>
                        ))}
                    </div>


                  </div>



                </div>

              </main>
            </div>
          </div>
        }
        {
          modal &&

          <div style={{ backgroundColor: "#F2F4F7", marginTop: '10px' }}>
            <div className="t-wrapper-div" style={{ padding: modal ? "10px" : "0", margin: modal ? "0" : '' }}>
              <main className="flex-1 p-10 bg-white" style={{ padding: "10px" }}>
                <h4>{isSuperVission ? "Supervisor Personality" : "Match 2"}</h4>
                <div className='sticky-position-for-behavior-color-code'>
                  <div className={`behavior-page-header-grid ${modal ? "behavior-page-header-grid--modal" : ""}`}>
                    {/* <div className="col-md-12"> */}

                    <div className="col-md-3--"

                      style={{ display: "flex--", gap: "8px", alignItems: "center", justifySelf: 'start' }}
                    >
                      <div style={{
                        display: "flex--",
                        alignItems: 'center', gap: '16px'
                      }}>
                        <div style={{
                          display: "flex",
                          alignItems: 'center', gap: '16px'
                        }} >
                          <h4
                            style={{
                              fontSize: "var(--font-size-h4)",
                              letterSpacing: "0.15px",
                              fontWeight: 500,
                              display: "contents",

                            }}
                            className="font-color-text"
                          >
                            Please Select 4 behaviors
                          </h4>
                          <div
                            style={{
                              backgroundColor:'var(--brand-primary)',
                              fontSize: "var(--font-size-base)",
                              color: "white",
                              padding: "6px 16px",
                              borderRadius: "16px",
                            }}
                          >
                            {personalitytwosel?.length}/4
                          </div>
                        </div>

                      </div>

                    </div>

                    <div className="col-md-3--" style={{ display: 'flex', gap: "16px", justifySelf: "start", alignSelf: 'center' }}>
                      <div className='recommeded-flex-box'>

                        {!modal && (
                          <>
                            {/* <img src={recomented} style={{ width: '20px', height: '20px' }} /> */}
                            <span className='' style={{ display: 'inline' }}>
                              <svg width="21" height="20" viewBox="0 0 21 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M10.2612 13.2966L9.545 14.9366C9.26958 15.567 8.3975 15.567 8.12208 14.9366L7.40583 13.2966C6.76875 11.837 5.62167 10.6753 4.19083 10.0403L2.22 9.16531C1.59333 8.88698 1.59333 7.97573 2.22 7.6974L4.12958 6.8499C5.59708 6.19865 6.76458 4.99365 7.39083 3.48448L8.11625 1.73656C8.38542 1.08781 9.28167 1.08781 9.55083 1.73656L10.2762 3.48448C10.9025 4.99365 12.07 6.19865 13.5375 6.8499L15.4471 7.6974C16.0737 7.97573 16.0737 8.88698 15.4471 9.16531L13.4762 10.0403C12.0454 10.6753 10.8983 11.8374 10.2612 13.2966Z" fill="#2196F3" />
                                <path d="M16.5096 18.02L16.3042 18.4912C16.1537 18.8362 15.6762 18.8362 15.5258 18.4912L15.3204 18.02C14.9542 17.18 14.2937 16.5112 13.4704 16.145L12.8371 15.8637C12.4946 15.7116 12.4946 15.2137 12.8371 15.0616L13.435 14.7958C14.2796 14.4204 14.9517 13.7271 15.3117 12.8583L15.5229 12.3491C15.67 11.9941 16.1608 11.9941 16.3079 12.3491L16.5192 12.8583C16.8792 13.7271 17.5512 14.4204 18.3958 14.7958L18.9937 15.0616C19.3362 15.2137 19.3362 15.7116 18.9937 15.8637L18.3604 16.145C17.5362 16.5112 16.8762 17.18 16.5096 18.02Z" fill="#7E57C2" />
                              </svg>

                            </span>
                          </>
                        )}


                        {!modal && (
                          <p className='my-header-text'>
                            Behaviors recommended by LYWO's AI
                          </p>
                        )}
                      </div>

                    </div>


                    <div className="col-md-3--" style={{ paddingTop: '' }}>

                      <div style={{ display: "flex", justifyContent: "flex-end", gap: '10px' }}>
                        <div className="no-print ">
                          <CustomButton
                            title="Check Personalities"
                            iconToLeft={User}
                            isLoading={isLoadingTwo}
                            disabled={checkPersonalityLoading}
                            buttonType="secondary"
                            fontSize='11px'
                                forChechPer ={true}
                            handleClick={async () => {


                              if (personalitytwosel?.length < 4) {
                                toastMsg("error", 'Please select 4 behaviors');
                                return
                              }

                              await getPersonalityMatches(false, true)
                              handleShowPersonality()
                            }}
                          />


                        </div>
                        <div className="no-print ">
                          <CustomButton
                            title="Apply"
                            type="button"
                            isLoading={applyTeoLoad}
                            isDisabled={applyTeoLoad}
                           
                            buttonType="primary"
                            handleClick={() => {
                              if (personalitytwosel?.length < 4) {
                                toastMsg('error', 'Please select Match 2 of 4 behaviors ')
                                return
                              }
                              setApplyTwoLoad(true)
                              getPersonalityMatches(true, true)
                            }}
                          />
                        </div>
                      </div>
                    </div>
                    {/* </div> */}
                  </div>


                </div>
                <div className='scroll-div-behavior'>
                  <div className="mt-3-- be-3">Behaviors</div>
                  <div className="col-md-12 mt-2">
                    <div className='row'
                      style={{
                        display: "flex",
                        rowGap: "24px",
                        // alignItems: "center",
                        // flexWrap: "wrap",
                      }}
                    >

                      {traits.map((trait, index) => (
                        <div
                          className="col-md-3"
                          key={index}
                          style={{ display: "flex", alignItems: "center", gap: "6px", marginBottom: '3px' }}
                        >
                          <div
                            style={{
                              width: "12px",
                              height: "12px",
                              backgroundColor: trait.color,
                              borderRadius: "2px",
                            }}
                          ></div>
                          <span className="be-2 color-group-box font-color-text">{trait.name}</span>
                        </div>
                      ))}



                    </div>


                    <div className="row">
                      {groupedData
                        .filter(group => group.cards.length > 0)
                        .map((group, groupIndex) => (
                          <div className="col-md-3" key={groupIndex}>

                            {group.cards.map((item, index) =>
                              renderCard(item, index, item.sectionType, item.title, true)
                            )}
                          </div>
                        ))}
                    </div>


                  </div>


                </div>
                <div className="d-flex justify-content-end mt-2">
                  <CustomButton
                    title="Close"
                    type="button"

                    fontSize='11px'
                    buttonType="secondary"
                    handleClick={() => {
                      handleCloseBehaviour()
                    }}
                  />
                </div>
              </main>
            </div>
          </div>
        }
      </div>

      <>
        <Modal style={{ transform: 'translateY(-1%)' }} className='custom-modal-for-behavior-popup---' show={showPersonality} onHide={handleClosePersonality} dialogClassName="modal-h-650">
          <Modal.Header closeButton className="custom-close-btn--" style={{ padding: '8px 16px' }}>
            <h6 className="mb-0 mt-1" style={{ fontSize: '14px--', color: '#333' }}>Personality matches</h6>
          </Modal.Header>
          <Modal.Body style={{ paddingTop: '4px' }}>
            <div className='personality-matches-heading'>
              {/* <div><p className='m-1 choosen-behavior-text' style={{ fontSize: 'var(--font-size-base)', fontWeight: '600', color: '#51607a' }}>Choosen Behaviors  </p></div> */}
              <div className='personality-matches-behaviors'>

                {(selectedRecommendedIndexes?.length > 0 || selectedOtherIndexes?.length > 0) && [...selectedRecommendedIndexes, ...selectedOtherIndexes]?.map((item, index) => (
                  <div key={index}> <p className='choosen-behavior-text' style={{ color: '#384b68', paddingBottom: '0', marginBottom: '4px' }} >{item}</p></div>
                ))}
              </div>
            </div>

            {/* <div className='personality-matches-grid'> style={{overflowY : 'scroll', scrollbarWidth:'thin', height:'100vh'}} */}
            <div >
              {CheckPersonalityData?.length > 0 && CheckPersonalityData?.map(((item, index) => (
                <div className='personality-matches-grid' key={index}>
                  <div>
                    <p className='personality-names' onClick={() => handleShowPersonalityPopup(item.name, item.percentage)}>{item.name}  </p>
                  </div>
                  <div style={{ justifySelf: 'end' }}>
                    <p className='personality-matches-input ' > <span style={{ display: 'inline-block', width: '20px' }}>{item.percentage}</span> </p> <span style={{ color: '#6B778C', fontSize: 'var(--font-size-base)', fontWeight: '500' }}> % </span>
                  </div>
                </div>

              )))}
            </div>


          </Modal.Body>

        </Modal>
        <Modal className='custom-modal-for-behavior-popup modal-md' centered show={show} onHide={handleClose} style={{ borderRadius: '24px' }} dialogClassName="modal-h-650">
          {/* <Modal.Header closeButton className="custom-close-btn d-flex justify-content-start" style={{
            border:'none',
            paddingBottom:'0'
          }}>

            <h6 className="mb-0 mt-1" style={{fontWeight:'600', fontSize:'var(--font-size-h4)', marginRight:'4px'}}>{
              recommendedData[popupIndex]?.title || otherData[popupIndex]?.title
            }</h6>
            <span className='' style={{display:'inline'}}>
                        <svg width="21" height="20" viewBox="0 0 21 20" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M10.2612 13.2966L9.545 14.9366C9.26958 15.567 8.3975 15.567 8.12208 14.9366L7.40583 13.2966C6.76875 11.837 5.62167 10.6753 4.19083 10.0403L2.22 9.16531C1.59333 8.88698 1.59333 7.97573 2.22 7.6974L4.12958 6.8499C5.59708 6.19865 6.76458 4.99365 7.39083 3.48448L8.11625 1.73656C8.38542 1.08781 9.28167 1.08781 9.55083 1.73656L10.2762 3.48448C10.9025 4.99365 12.07 6.19865 13.5375 6.8499L15.4471 7.6974C16.0737 7.97573 16.0737 8.88698 15.4471 9.16531L13.4762 10.0403C12.0454 10.6753 10.8983 11.8374 10.2612 13.2966Z" fill="#2196F3"/>
<path d="M16.5096 18.02L16.3042 18.4912C16.1537 18.8362 15.6762 18.8362 15.5258 18.4912L15.3204 18.02C14.9542 17.18 14.2937 16.5112 13.4704 16.145L12.8371 15.8637C12.4946 15.7116 12.4946 15.2137 12.8371 15.0616L13.435 14.7958C14.2796 14.4204 14.9517 13.7271 15.3117 12.8583L15.5229 12.3491C15.67 11.9941 16.1608 11.9941 16.3079 12.3491L16.5192 12.8583C16.8792 13.7271 17.5512 14.4204 18.3958 14.7958L18.9937 15.0616C19.3362 15.2137 19.3362 15.7116 18.9937 15.8637L18.3604 16.145C17.5362 16.5112 16.8762 17.18 16.5096 18.02Z" fill="#7E57C2"/>
</svg>

</span>
<div>

</div>
          </Modal.Header> */}
          <Modal.Body>
            {
              (() => {
                const cardData = section === 'recommended' ? recommendedData : otherData;
                const modalItem = cardData.find(item => item.title === popupTitle); // ✅ Changed from indexing to search by title
                console.log('datac', modalItem);
                return renderCardVersionTwo(modalItem || [], 0, section, modalItem?.title, true); // ✅ Index replaced with 0, title used instead
              })()
            }
          </Modal.Body>
          {/* <Modal.Footer>
      
                  <CustomButton
                    title={'Close'}
                    handleClick={handleClose}
                    buttonType='secondary'
      
                  />
      
                  <CustomButton
                    title={'Save'}
                    handleClick={handleSubmit}
      
                    isLoading={isSubmit}
                  />
                </Modal.Footer> */}
        </Modal>
        <Modal style={{ zIndex: '10000' }} className='custom-modal-for-behavior-popup-big modal-lg' centered show={bigshow} onHide={handleCloseBig} dialogClassName="modal-h-650">
          <Modal.Header closeButton className="custom-close-btn flex-column">

            <div>
              <h6 className="mb-1 mt-1 font-color-text" style={{ fontSize: 'var(--font-size-h4)', color: '#172b4d' }}>{modalText}  <span style={{ color: 'var(--brand-primary)' }}> {titleToShowOnBehaviorModal} </span> </h6>
            </div>

            <div>
              {/* <h6 className="mb-0 mt-1" style={{ fontSize: 'var(--font-size-h4)', color: '#51607A', textAlign: 'center' }}>You have  <span style={{ color: '#FB7185' }}> {selectedRecommendedIndexes?.length + selectedOtherIndexes?.length || 4} behaviors selected. </span> {(selectedRecommendedIndexes?.length + selectedOtherIndexes?.length) > 3 && 'Please select one that you want to replace.'}</h6> */}
              <h6
                className="mb-0 mt-1"
                style={{ fontSize: 'var(--font-size-h4)', color: '#51607A', textAlign: 'center' }}
              >
                You have
                <span style={{ color: '#FB7185' }}>
                  {(personalitytwosel.length || (selectedRecommendedIndexes?.length + selectedOtherIndexes?.length))} behaviors selected.
                </span>

                {(personalitytwosel?.length > 3 || (selectedRecommendedIndexes?.length + selectedOtherIndexes?.length) > 3) && (
                  <>
                    <br />
                    Please <span style={{ color: '#FB7185' }}>select one </span>that you want to {' '}
                    <span style={{ color: '#FB7185' }}>replace</span>.
                  </>
                )}

              </h6>
            </div>
          </Modal.Header>
          {/* renderCard(item, index, item.section, item.title, true, true, true, false, ) */}
          <Modal.Body>
            <div className='behavor-popup-grid--v2'>
              {combinePopupData?.map((item, index) => (



                deselectRenderCar(item, index, item.section, item.title, true, true, true, false,)



              ))}

            </div>

          </Modal.Body>
          <Modal.Footer>




          </Modal.Footer>
        </Modal>

        <Modal
          show={showmodalPersonality}
          onHide={handleClosePersonalityPopup}
          dialogClassName="custom-modal position-relative modal-h-650"
          size="lg"
        >
          <div
            className="position-absolute btn btn-close"
            style={{ top: "25px", right: "20px", zIndex: "99" }}
            onClick={() => setShowmodalPersonality(false)}
          ></div>
          <Modal.Body>
            <div className="row">
              {onePer.map((personality, index) => (
                <div key={index} className="col border rounded-3 mx-2">
                  <div className="row">
                    <div className="col-12" style={{ background: "#FFE6D5" }}>
                      <div className="row justify-content-between align-items-center mt-5">
                        <div className="col-6">
                          <img src={personality.img_card} alt="card-image"></img>
                        </div>
                        <div className="col-6">
                          <div className="row flex-column align-items-center">
                            <div className="col-6 d-flex justify-content-center ">
                              <img
                                width={50}
                                src={personality.img_letter}
                                alt="card-image-letter"
                              />
                            </div>
                            <div className="col-12">
                              <p
                                className="text-center"
                                style={{
                                  fontSize: "var(--font-size-h1)",
                                  fontWeight: "600",
                                  lineHeight: "60px",
                                }}
                              >
                                {personality.personality}
                              </p>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="col-12">
                      <div className="row justify-content-end">
                        <div className="col-12 my-4 d-flex justify-content-start">
                          {/* <img
                            className="me-2"
                            width={40}
                            src={personality.img_letter}
                            alt="personality-letter"
                          />
                     
                          <h4
                            className="my-auto"
                            style={{ fontSize: "var(--font-size-h1)", fontWeight: "600" }}
                          >
                            {personality.personality}
                          </h4> */}
                        </div>
                        <div className="col-10 mx-auto">
                          <p style={{ fontSize: "var(--font-size-base)" }}>{personality.text}</p>
                          <hr />
                        </div>
                        <div className="col-10 mx-auto mb-5">
                          <div className="row">
                            <div className="col-2">
                              <p style={{ fontSize: "var(--font-size-base)" }} className="">
                                <strong>Strengths</strong>
                              </p>
                            </div>
                            <div className="col">
                              <p style={{ fontSize: "var(--font-size-base)" }}>
                                {personality.strengths}
                              </p>
                            </div>
                          </div>

                          <div className="row">
                            <div className="col-2">
                              <p style={{ fontSize: "var(--font-size-base)" }} className="">
                                <strong>Uniqueness</strong>
                              </p>
                            </div>
                            <div className="col">
                              <p style={{ fontSize: "var(--font-size-base)" }}>
                                {personality.uniqueness}
                              </p>
                            </div>
                          </div>

                          <div className="row">
                            <div className="col-2">
                              <p
                                style={{ fontSize: "var(--font-size-base)" }}
                                className="text-nowrap"
                              >
                                <strong>Value to Org.</strong>
                              </p>
                            </div>
                            <div className="col">
                              <p style={{ fontSize: "var(--font-size-base)" }}>
                                {personality.valtoorg}
                              </p>
                            </div>
                          </div>

                          <div className="row">
                            <div className="col-2">
                              <p
                                style={{ fontSize: "var(--font-size-base)" }}
                                className="text-nowrap"
                              >
                                <strong>Challenges</strong>
                              </p>
                            </div>
                            <div className="col">
                              <p style={{ fontSize: "var(--font-size-base)" }}>
                                {personality.challenges}
                              </p>
                            </div>
                          </div>

                          <div className="row">
                            <div className="col-2">
                              <p style={{ fontSize: "var(--font-size-base)" }} className="">
                                <strong>Motivations</strong>
                              </p>
                            </div>
                            <div className="col">
                              <p style={{ fontSize: "var(--font-size-base)" }}>
                                {personality.motivations}
                              </p>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </Modal.Body>
          {/* <Modal.Header closeButton className="custom-close-btn">
                      </Modal.Header>
                    <Modal.Body>
                      <div className="row">
              
                      <div className="col p-3 border rounded-3">
                                          <div className="">
                                               <div className="d-flex px-3">
                                                  <h4 style={{fontSize:"var(--font-size-h4)", fontWeight:"700", lineHeight:"30px"}} className="me-2">78%</h4>
                                                  <p>----------------------</p>
                                              </div>
                                           <div className="d-flex align-items-center ms-2" style={{cursor:"pointer"}} onClick={handleShowPersonalityCard}>
                                              <img className="me-2" width={40} src={mediatorLetter}/>
                                              <h4 className="mb-0" style={{fontSize:"var(--font-size-h4)", fontWeight:"700"}}>Mediator</h4>
                                           </div>
                                          </div>
                              </div>
                      </div>
                    </Modal.Body> */}
        </Modal>
        {console.log('combinePopupData--', combinePopupData)}
      </>
    </div >
  );
}
